import { ArrowLeft as o } from "../icons-24/arrows/arrow-left.js";
import { ArrowRight as r } from "../icons-24/arrows/arrow-right.js";
import { ArrowBottom as m } from "../icons-24/arrows/arrow-bottom.js";
import { ArrowRightSmall as t } from "../icons-24/arrows/arrow-right-small.js";
import { ChevronUp as i } from "../icons-24/arrows/chevron-up.js";
import { ChevronDown as f } from "../icons-24/arrows/chevron-down.js";
import { ChevronLeft as p } from "../icons-24/arrows/chevron-left.js";
import { ChevronRight as l } from "../icons-24/arrows/chevron-right.js";
import { ChevronUpSmall as e } from "../icons-24/arrows/chevron-up-small.js";
import { ChevronDownSmall as n } from "../icons-24/arrows/chevron-down-small.js";
import { ChevronLeftSmall as a } from "../icons-24/arrows/chevron-left-small.js";
import { ChevronRightSmall as c } from "../icons-24/arrows/chevron-right-small.js";
import { ChevronLeftExtraSmall as s } from "../icons-16/chevron-left-extra-small.js";
import { ChevronRightExtraSmall as C } from "../icons-16/chevron-right-extra-small.js";
import { Download as h } from "../icons-24/arrows/download.js";
import { LinkedinSmall as S } from "../icons-24/extra-24/linkedin-small.js";
import { FacebookSmall as v } from "../icons-24/extra-24/facebook-small.js";
import { TwitterSmall as w } from "../icons-24/extra-24/twitter-small.js";
import { DocumentLines as g } from "../icons-24/files/document-lines.js";
import { DocumentStack as d } from "../icons-24/files/document-stack.js";
import { Reporting as k } from "../icons-24/files/reporting.js";
import { CheckmarkCircleFill as u } from "../icons-24/interface/checkmark-circle-fill.js";
import { Clock as A } from "../icons-24/interface/clock.js";
import { Collections as D } from "../icons-24/interface/collections.js";
import { Copy as L } from "../icons-24/interface/copy.js";
import { Cross as R } from "../icons-24/interface/cross.js";
import { CrossCircleFill as F } from "../icons-24/interface/cross-circle-fill.js";
import { PlayCircle as x } from "../icons-24/interface/play-circle.js";
import { Search as y } from "../icons-24/interface/search.js";
import { Plus as E } from "../icons-24/interface/plus.js";
import { Diversity as P } from "../icons-24/shapes/diversity.js";
import { CircleFill as b } from "../icons-24/shapes/circle-fill.js";
import { Academy as U } from "../icons-24/various/academy.js";
import { Globe as B } from "../icons-24/various/globe.js";
import { Knowledge as G } from "../icons-40/products/knowledge.js";
const I = {
  ArrowLeft: o,
  ArrowBottom: m,
  ArrowRight: r,
  ArrowRightSmall: t,
  ChevronUp: i,
  ChevronUpSmall: e,
  ChevronDown: f,
  ChevronDownSmall: n,
  ChevronLeft: p,
  ChevronLeftSmall: a,
  ChevronLeftExtraSmall: s,
  ChevronRight: l,
  ChevronRightSmall: c,
  ChevronRightExtraSmall: C,
  Download: h
}, K = { LinkedinSmall: S, FacebookSmall: v, TwitterSmall: w }, T = { DocumentLines: g, DocumentStack: d, Reporting: k }, V = { CheckmarkCircleFill: u, Clock: A, Collections: D, Copy: L, Cross: R, CrossCircleFill: F, PlayCircle: x, Search: y, Plus: E }, j = { Diversity: P, CircleFill: b }, q = { Academy: U, Globe: B }, z = { Knowledge: G }, Lo = {
  Arrows: I,
  Extra24: K,
  Files: T,
  Interface: V,
  Shapes: j,
  Various: q,
  Products: z
};
export {
  Lo as default
};
